var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 1.66699C5.41797 1.66699 1.66797 5.41699 1.66797 9.99999C1.66797 14.583 5.41797 18.333 10.001 18.333C14.584 18.333 18.334 14.583 18.334 9.99999C18.334 5.41699 14.584 1.66699 10.001 1.66699ZM12.959 13.167L9.55897 11.075C9.43655 11.0019 9.33529 10.8981 9.26516 10.774C9.19502 10.6498 9.15842 10.5096 9.15897 10.367V6.45799C9.16335 6.29206 9.23183 6.13428 9.35004 6.01775C9.46825 5.90122 9.62699 5.835 9.79297 5.83299C9.95832 5.8343 10.1165 5.90057 10.2335 6.0175C10.3504 6.13442 10.4167 6.29264 10.418 6.45799V10.166L13.618 12.091C13.918 12.275 14.018 12.666 13.834 12.967C13.7435 13.1084 13.6011 13.2087 13.4374 13.2461C13.2737 13.2835 13.1019 13.2551 12.959 13.167Z",
    fill: "url(#paint0_linear_52_367)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_367",
    x1: 18.334,
    y1: 9.99999,
    x2: 1.66797,
    y2: 9.99999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB0067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2784CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorario);
export default __webpack_public_path__ + "static/media/horario.237720ce01c5077f7572d63946539785.svg";
export { ForwardRef as ReactComponent };